import { InputMaskProcessingBase } from '../input-mask-processing.base';

export class PhoneMaskProcessing extends InputMaskProcessingBase {
  protected allowedChars = '0123456789';
  protected fixedPosGroupingChars = ['(', null, null, null, ')', ' ', null, null, null, '-'];
  protected maxLength = 14;
}
